import type { ComponentChildren, JSX } from "preact";
import { classNames } from "@gss/common/classNames";

interface Props {
    className?: string;
    children?: ComponentChildren;
}

export function Row({ className, children }: Props): JSX.Element {
    return <div className={classNames("row", className)}>{children}</div>;
}
